import Vue from 'vue'
import { init, captureException } from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

const isProd = process.env.NODE_ENV === 'production'
if (process.client) {
  window.onerror = function(message, source, lineno, colno, error) {
    return true
  }
  window.addEventListener('unhandledrejection', function(e) {
    e.preventDefault()
    return true
  })
}

if (process.env.VER_ENV) {
  init({
    dsn: 'https://97f0e75a88454a308161fa35d32d270e@sentry-wan-ssl.xunlei.com/2',
    release: `xlwan@${process.env.VER_ENV}`,
    integrations: [new VueIntegration({ Vue, attachProps: true })]
  })
}

export const sentryReport = ['info', 'debug', 'warn', 'error'].reduce(
  (pre, level) => {
    pre[level] = function(error) {
      if (!isProd) {
        // eslint-disable-next-line no-console
        console[level](error)
        return
      }
      if (process.env.VER_ENV) {
        captureException(error)
      }
    }
    return pre
  },
  {}
)

export default function(_, inject) {
  inject('sentry', sentryReport)
}
